import { lazy, Suspense } from "react"
import { useLanguageStore } from "../state-management/languageStore"

const SearchPageContent = lazy(
    () => import("../components/SearchPageComponents/SearchPageContent"),
)
function Search({ data }) {
    const t = useLanguageStore((state) => state.translate)
    return (
        <Suspense fallback={<div></div>}>
            <SearchPageContent
                data={data}
                showFilter={true}
                title={t("search.allTitle")}
                notFoundTitle={t("search.allEmpty")}
            />
        </Suspense>
    )
}

export default Search
